import React, { useContext, useEffect, useState } from "react";
import { Button, ColorPicker, Form, Input, Space, Tag } from "antd";
import { IconPicker } from "react-fa-icon-picker";
import ModalTags from "../GeoUnit/ModalTags";
import { context } from "../../context/context";
import { http } from "../../services/httpService";
import config from "../../services/config.json";
import TextEditorModal from "./../Place/TextEditorModal";
const NewsForm = () => {
    const [form] = Form.useForm();
    // state
    const [isEditSelected, setIsEditSelected] = useState(false);
    const [inputTitleStyle, setInputTitleStyle] = useState({
        width: "100%",
        outline: "0",
    });
    // context
    const {
        selectedNewsId,
        setNewsTags,
        setTextEditorShow,
        setTextEditorHTML,
        newsTitle,
        setNewsTitle,
        newsLinks,
        setNewsLinks,
        newsLinkColor,
        setNewsLinkColor,
        newsLinkIcon,
        setNewsLinkIcon,
        newsLinkUrl,
        setNewsLinkUrl,
        setNewsMedia,
        setNewsCover,
        newstitleUrl,
        setNewstitleUrl,
    } = useContext(context);
    // useEffect
    useEffect(() => {
        if (selectedNewsId) {
            http.get(`${config.parkopoloApi}/api/News/${selectedNewsId}`)
                .then((res) => {
                    setNewsLinks(res.data.result.links);
                    setNewsTitle(res.data.result.title);
                    setNewsTags(res.data.result.tags);
                    setTextEditorHTML(res.data.result.data);
                    setNewsCover([res.data.result.coverPic]);
                    setNewsMedia(res.data.result.media);
                })
                .catch((err) => {
                    console.log(err);
                });
            setIsEditSelected(true);
        }
    }, []);
    // functions
    const handleDeleteLink = (url) => {
        const links = newsLinks.filter((link) => link.url !== url);
        setNewsLinks(links);
    };
    const handleTitleChange = (e) => {
        setNewsTitle(e.target.value);
    };
    const onUrlTitleChange = (e) => {
        setNewstitleUrl(e.target.value);
    };
    const handleColorChange = (color) => {
        setNewsLinkColor(color);
    };
    const handleIconChange = (e) => {
        setNewsLinkIcon(e);
    };
    const onUrlChange = (e) => {
        setNewsLinkUrl(e.target.value);
    };
    const handleAddLink = () => {
        const color = document.querySelector(
            ".ant-color-picker-trigger-text"
        ).innerText;
        const newLink = {
            name: newstitleUrl,
            url: newsLinkUrl,
            color: color,
            icon: newsLinkIcon,
        };
        setNewsLinks([...newsLinks, newLink]);
        setNewsLinkUrl(null);
        setNewsLinkColor(null);
        setNewsLinkIcon(null);
        setNewstitleUrl(null);
    };
    return (
        <div
            style={{
                direction: "rtl",
                display: "flex",
                gap: "15px",
                margin: "15px",
            }}
        >
            <Form
                layout="vertical"
                form={form}
                name="control-hooks"
                style={{
                    width: "100%",
                }}
            >
                <div style={{ display: "flex", gap: "2rem" }}>
                    <Form.Item
                        name="عنوان"
                        label="عنوان"
                        style={{ width: "100%" }}
                    >
                        <h4 style={{ textAlign: "right", display: "none" }}>
                            در حال ویرایش {newsTitle}
                        </h4>
                        <input
                            style={inputTitleStyle}
                            className="ant-input css-dev-only-do-not-override-lzp0br css-dev-only-do-not-override-lzp0br"
                            type="text"
                            value={isEditSelected ? newsTitle : null}
                            onChange={handleTitleChange}
                            placeholder="عنوان را وارد کنید"
                            onFocus={() => {
                                const updatedStyle = {
                                    ...inputTitleStyle,
                                    outline: "1px solid #48D1CC",
                                    borderColor: "#48D1CC",
                                };
                                setInputTitleStyle(updatedStyle);
                            }}
                            onBlur={() => {
                                const updatedStyle = {
                                    ...inputTitleStyle,
                                    outline: "",
                                    borderColor: "",
                                };
                                setInputTitleStyle(updatedStyle);
                            }}
                            onMouseEnter={() => {
                                const updatedStyle = {
                                    ...inputTitleStyle,
                                    borderColor: "#48D1CC",
                                };
                                setInputTitleStyle(updatedStyle);
                            }}
                            onMouseLeave={() => {
                                const updatedStyle = {
                                    ...inputTitleStyle,
                                    borderColor: "",
                                };
                                setInputTitleStyle(updatedStyle);
                            }}
                        />
                    </Form.Item>
                </div>
                <div
                    style={{
                        display: "flex",
                        gap: "30px",
                        alignItems: "center",
                    }}
                >
                    <Form.Item
                        name="عنوان لینک"
                        label="عنوان لینک"
                        style={{ width: "100%" }}
                    >
                        <h4 style={{ textAlign: "right", display: "none" }}>
                            در حال ویرایش {newstitleUrl}
                        </h4>
                        <Input
                            value={newstitleUrl}
                            onChange={onUrlTitleChange}
                            placeholder="عنوان لینک را وارد کنید"
                        />
                    </Form.Item>
                    <Form.Item
                        name="آدرس لینک"
                        label="آدرس لینک"
                        style={{ width: "100%" }}
                    >
                        <h4 style={{ textAlign: "right", display: "none" }}>
                            در حال ویرایش {newsLinkUrl}
                        </h4>
                        <Input
                            value={newsLinkUrl}
                            onChange={onUrlChange}
                            placeholder="آدرس لینک را وارد کنید"
                        />
                    </Form.Item>
                    <Form.Item label="آیکون لینک" name="آیکون لینک">
                        <h4 style={{ textAlign: "right", display: "none" }}>
                            در حال ویرایش {newsLinkIcon}
                        </h4>
                        <IconPicker
                            value={newsLinkIcon}
                            buttonStyles={{
                                padding: "0 2.5rem",
                                border: "1px solid silver",
                                width: "100%",
                            }}
                            onChange={(e) => handleIconChange(e)}
                        />
                    </Form.Item>
                    <Form.Item label="رنگ لینک" name="رنگ">
                        <ColorPicker
                            value={newsLinkColor}
                            onChange={handleColorChange}
                            style={{
                                padding: "1.5rem",
                                width: "100%",
                            }}
                            showText
                        />
                    </Form.Item>
                    <Button
                        onClick={handleAddLink}
                        disabled={
                            newstitleUrl === "" ||
                            !newstitleUrl ||
                            !newsLinkColor ||
                            !newsLinkIcon ||
                            !newsLinkUrl ||
                            newsLinkUrl.slice(0, 8) !== "https://"
                        }
                    >
                        اضافه کردن لینک جدید
                    </Button>
                </div>
                <Space wrap>
                    {newsLinks.map((link) => {
                        return (
                            <Tag
                                color="blue"
                                closeIcon
                                key={link.url}
                                onClose={() => handleDeleteLink(link.url)}
                            >
                                {link.url}{" "}
                                <i
                                    className={`fa ${link.icon
                                        .split(/(?=[A-Z])/)
                                        .map((word) => word.toLowerCase())
                                        .join("-")}`}
                                    style={{ fontSize: "10px" }}
                                />
                            </Tag>
                        );
                    })}
                </Space>

                <Form.Item name="تگ" label="تگ ها">
                    <div>
                        <ModalTags section="news" />
                    </div>
                </Form.Item>
                <Form.Item name="ویرایشگر متن">
                    <Button
                        onClick={() => setTextEditorShow(true)}
                        type="primary"
                    >
                        ویرایشگر متن
                    </Button>
                </Form.Item>
            </Form>
            <TextEditorModal />
        </div>
    );
};

export default NewsForm;
